import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
// import WizardTopHeader from "components/wizard/Topheader";
import { useWizard } from "components/wizard/WizardContext";
import ALoader from "views/pages/manage/common/a-loader";
import _ from "lodash";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { fetchVendorData, vendorDetailsLabelFieldMapping } from "../helper";
import styles from "../styles.module.scss";
import Footer from "modules/studentRefund/completionRefund/reinitiate/components/Footer";
import { useFetchVendorData } from "../customHook";
import VendorDetails from "./VendorDetails";
import { defaultStreamValues } from "../config"

const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddDetails = ({ isShowFooter = true, readOnly = false }) => {
    const { values, updateValues, dropdowns, next } = useWizard();
    const { fetchVendorData } = useFetchVendorData();
    const { vendorDetails } = values;
    const { businessAreas, year, allVendors } = dropdowns?.data;
    const [form, setForm] = useState(values?.addVendorForm ?? {});

    const handleForm = (val, key) => {
        if (readOnly) return;

        setForm((prev) => {
            const updated = { ...prev, [key]: val };
            updateValues("addVendorForm", updated);
            return updated;
        });
    };

    const handleCheckDetails = () => {
        if (readOnly) return;

        updateValues("SOF", { ...defaultStreamValues });
        updateValues("SOM", { ...defaultStreamValues });
        updateValues("SOE", { ...defaultStreamValues });

        fetchVendorData(form);
    };

    const isCheckDisabled =
        !form?.businessArea || !form?.year || !form?.vendorId || readOnly;

    return (
        <>
            {(dropdowns?.loading || values?.vendorDetailsLoading) && <ALoader position={"fixed"} />}
            <div style={{ paddingBottom: isShowFooter ? "120px" : "20px" }}>

                <Card style={{ margin: "15px" }}>
                    {/* <h4 className="color-black">Add Details</h4> */}
                    <div className={styles['dropdown-container']}>
                        <div className={styles['label']}>Add Details</div>
                        <div className={styles['dropdowns']}>
                            <AAutoComplete
                                label='Vendor Id'
                                labelStyle={labelStyle}
                                currentValue={form?.vendorId}
                                handleChange={(value) => {
                                    handleForm(value, "vendorId")
                                }}
                                items={allVendors}
                                isMulti={false}
                                placeholder={"Select"}
                                isDisabled={readOnly}
                            />
                            <AAutoComplete
                                label='Business Unit'
                                labelStyle={labelStyle}
                                currentValue={form?.businessArea}
                                handleChange={(value) => {
                                    handleForm(value, "businessArea")
                                }}
                                items={businessAreas}
                                isMulti={false}
                                placeholder={"Select"}
                                isDisabled={readOnly}
                            />
                            <AAutoComplete
                                label='Year'
                                labelStyle={labelStyle}
                                currentValue={form?.year}
                                handleChange={(value) => {
                                    handleForm(value, "year")
                                }}
                                items={year}
                                isMulti={false}
                                placeholder={"Select"}
                                isDisabled={readOnly}
                            />

                            <div className={styles['buttonWrapper']}>
                                <AButton
                                    variant="primary_filled"
                                    onClick={handleCheckDetails}
                                    size="xs"
                                    disabled={isCheckDisabled}
                                >
                                    Check Details
                                </AButton>
                            </div>

                        </div>
                    </div>
                </Card>

                {!_.isEmpty(vendorDetails) &&
                    <Card style={{ margin: "15px" }}>
                        <VendorDetails
                            vendorDetails={vendorDetails}
                            labelFieldMappings={vendorDetailsLabelFieldMapping()}
                        />
                    </Card>
                }
            </div>
            {isShowFooter &&
                <Footer>
                    <div>Raise a payment request</div>
                    <AButton
                        disabled={_.isEmpty(vendorDetails)}
                        onClick={() => { next(); }}
                        className="button_remove_left_margin"
                        variant="primary_filled"
                    >
                        Proceed next
                    </AButton>
                </Footer>
            }
        </>
    )
}

export default AddDetails